import { render, staticRenderFns } from "./main2.vue?vue&type=template&id=296245ab&scoped=true"
import script from "./main2.vue?vue&type=script&lang=js"
export * from "./main2.vue?vue&type=script&lang=js"
import style0 from "./main2.vue?vue&type=style&index=0&id=296245ab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296245ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296245ab')) {
      api.createRecord('296245ab', component.options)
    } else {
      api.reload('296245ab', component.options)
    }
    module.hot.accept("./main2.vue?vue&type=template&id=296245ab&scoped=true", function () {
      api.rerender('296245ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KeywordTag/main2.vue"
export default component.exports